export const TITLES = {
    editProductGST: "Edit Product GST",
    addProductGST: "Add Product GST",
    confirmDeletion: "Confirm Deletion",
    productGST: "Product GST",
}

export const LABELS = {
    product: "Product",
    gstPercent: "GST Percent",
    transportMode: "Transport Mode",
    productDescription: "Product Description",
    edit: "Edit",
    delete: "Delete",
}

export const MESSAGES = {
    addProductGSTSuccess: "Product GST Added Successfully",
    editProductGSTSuccess: "Product GST Updated Successfully",
    addProductGSTError: "Product GST Creation Failed",
    editProductGSTError: "Product GST Updation Failed",
    confirmDelete: "Are you sure you want to delete?",
    deleteProductGSTSuccess: "Product GST Deleted Successfully",
    deleteProductGSTError: "Product GST Deletion Failed",
    noRecordsFound: "No Records Found",
    onlyWholeNumberAllowed: "Only whole numbers are allowed",
}
